// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1LHOO","title":"ClientCherryInfo_title__1Ctu3","itemText":"ClientCherryInfo_itemText__2bR9m"};